import { ScoreDefinitionDTO } from 'business/models/Models';
import RMMultiSelectSearchDropdown from 'components/customComponents/CommonComponents/RMMultiSelectSearchDropdown';
import React, { useEffect, useMemo } from 'react';
import { useAllPlates } from 'redux/hooks/experiment';
import { GetScoreDefn } from 'utils/Global';
import { computeScoreFilterWells, getUsedScoreGroupIds } from '../filterComputations';
import { useFindDropContext } from '../FindDropContext';

const ScoresFilter = () => {
  const allScores: ScoreDefinitionDTO[] = GetScoreDefn();
  const {
    selectedScores,
    setSelectedScores,
    scoreFilterLogic,
    setScoreFilterLogic,
    setHighlightedScoreWells,
  } = useFindDropContext();
  const plates = useAllPlates();

  const usedScoreGroupIds = useMemo(() => getUsedScoreGroupIds(plates), [plates]);

  const canvasScores = useMemo(
    () => allScores.filter((score) => usedScoreGroupIds.has(score.wellDropScoreGroupId)),
    [allScores, usedScoreGroupIds],
  );

  useEffect(() => {
    setHighlightedScoreWells(
      computeScoreFilterWells(plates, selectedScores, scoreFilterLogic),
    );
  }, [selectedScores, scoreFilterLogic, plates, setHighlightedScoreWells]);

  return (
    <div className="flex flex-row px-[10px] gap-x-1 my-2">
      <div className="w-[30%]">Score Group</div>
      <RMMultiSelectSearchDropdown
        id="score-filter"
        options={canvasScores}
        selectedIds={selectedScores}
        onSelectionChange={setSelectedScores}
        filterLogic={scoreFilterLogic}
        onFilterLogicChange={setScoreFilterLogic}
        getOptionId={(item) => item.wellDropScoreId}
        getOptionLabel={(item) => item.scoreName}
        getOptionGroup={(item) => item.scoreGroupName}
        className="w-[70%]"
      />
    </div>
  );
};

export default ScoresFilter;
